export class InsulationElementType {
  static WALL = 1;
  static ROOF = 2;
  static FLOOR = 3;
  static BASEMENT_WALL = 4;
  static BASEMENT_FLOOR = 5;
}
